@if (application(); as application) {
    <div class="card mb-6">
        <div class="card-body flex flex-col gap-6">
            <div class="flex justify-between">
                <div class="text-secondary card-text">
                    @if (application.submissionDate) {
                        {{ 'applications.tile.submitted' | translate }}
                        {{ application.submissionDate | date: 'dd MMMM yyyy HH:mm' }}
                    } @else {
                        {{ 'applications.tile.created' | translate }}
                        {{ application.createdAt | date: 'dd MMMM yyyy HH:mm' }}
                    }
                    {{ 'applications.tile.time-suffix' | translate }}
                </div>
                <div class="flex flex-row gap-4 align-items-center">
                    <tran-application-status-indicator [status]="application.status" />
                    @if (visibleActions().length) {
                        <button
                            #menuTrigger="cdkOverlayOrigin"
                            class="btn btn-circle btn-lg btn-tertiary element-options-vertical"
                            [attr.aria-label]="
                                'applications.tile.options-aria-label' | translate: { name: application.name }
                            "
                            aria-haspopup="menu"
                            cdkOverlayOrigin
                            [class.show]="isMenuOpen()"
                            [attr.aria-expanded]="isMenuOpen()"
                            (click)="isMenuOpen.set(true)"
                        ></button>

                        <ng-template
                            cdkConnectedOverlay
                            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                            [cdkConnectedOverlayOpen]="isMenuOpen()"
                            [cdkConnectedOverlayOrigin]="menuTrigger"
                            [cdkConnectedOverlayPositions]="overlayPositions"
                            [cdkConnectedOverlayHasBackdrop]="true"
                            (backdropClick)="isMenuOpen.set(false)"
                            (detach)="isMenuOpen.set(false)"
                        >
                            <div
                                class="dropdown-menu position-static d-block"
                                cdkTrapFocus
                                [cdkTrapFocusAutoCapture]="true"
                            >
                                @for (action of visibleActions(); track action.id) {
                                    <button
                                        class="dropdown-item focus-inside gap-4"
                                        type="button"
                                        (click)="onActionClick(action)"
                                    >
                                        @if (action.icon) {
                                            <span class="text-lg" [class]="action.icon"></span>
                                        }
                                        {{ action.label | translate }}
                                    </button>
                                }
                            </div>
                        </ng-template>
                    }
                </div>
            </div>
            <h5 class="card-title flex flex-col gap-2" [attr.aria-label]="application.name">
                <span class="text-sm" aria-hidden="true">#{{ application.id }}</span>
                <span class="text-base">{{ application.name }}</span>
            </h5>
            <tran-application-requesters
                [requesters]="application.applicants"
                label="applications.tile.requester-label"
            />
            <ng-content slot="actions" />
        </div>
    </div>
}
